export const flushSSOStateReducer = {
  flushSSOState: (state, action) => {
    state.validateSSOTokenAPICall = {
      isLoading: false,
      isSuccess: false,
      isError: false,
      response: {},
    };
  },
};
